'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _NeutralBrandingRoutes = require('../../helpers/NeutralBrandingRoutes');

var _Router = require('../../helpers/Router');

var _ResetPasswordConfirmation = require('./ResetPasswordConfirmation.scss');

var _ResetPasswordConfirmation2 = _interopRequireDefault(_ResetPasswordConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordConfirmation = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ResetPasswordConfirmation, _Component);

  function ResetPasswordConfirmation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResetPasswordConfirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResetPasswordConfirmation.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.navigateToLogin = function () {
      var redirect_uri = _this.context.router.location.query.redirect_uri;

      (0, _Router.navigateAfterPasswordReset)(redirect_uri, _this.props.pushState);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResetPasswordConfirmation, [{
    key: 'render',
    value: function render() {
      var hasLoginButton = !this.props.auth.isMobile && (0, _Router.validateAppQueryParam)(this.context.router.location.query);
      var isNeutralRoute = (0, _NeutralBrandingRoutes.isNeutralBrandingRoute)(this.context.router.location.pathname);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ResetPasswordConfirmation2.default.resetPasswordConfirmation, { stingrayCorpo: isNeutralRoute }) },
        _react2.default.createElement(
          _components.DialogCard,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ResetPasswordConfirmationTitle),
            message: _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ResetPasswordConfirmationMessage)
          },
          hasLoginButton && _react2.default.createElement(
            'div',
            { className: _ResetPasswordConfirmation2.default.buttonContainer },
            _react2.default.createElement(_components.BaseButton, { onClick: this.navigateToLogin, buttonString: _DefaultString.translations.ResetPasswordConfirmationCTA })
          )
        ),
        _react2.default.createElement(_components.BrandLogos, null)
      );
    }
  }]);
  return ResetPasswordConfirmation;
}(_react.Component), _class2.propTypes = {
  pushState: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ResetPasswordConfirmation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResetPasswordConfirmation/ResetPasswordConfirmation.js
// module id = 2018
// module chunks = 0